import { useHistory } from "react-router-dom";
export default function useMemoryHistory() {
    return useHistory();
}
